import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} în {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Livrare',
    [ORDER_METHODS.PICKUP]: 'Ridicare',
    [ORDER_METHODS.ON_SITE]: 'Comandă la masă',
  },
};
